<template>
  <expandable-material-card
    :title="$t('components.portal.portal_settings.footer_items')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="list"
    style="margin-top: 30px"
  >
    <v-card-text>
      <v-form v-model="valid" v-if="portal !== null && portal !== undefined">
        <v-layout row wrap>
          <div
            class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
            v-for="lang in languages"
            :key="`leftText${lang.language}`"
          >
            <no-autocomplete-textfield
              v-model="
                portal.footerItems[`leftText${lang.language.toUpperCase()}`]
              "
              :label="
                $t(
                  `components.portal.portal_settings.footer_items.left_text_{0}`,
                  [lang.language.toUpperCase()]
                )
              "
              clearable
            ></no-autocomplete-textfield>
          </div>
          <div
            class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
            v-for="lang in languages"
            :key="`leftLogo${lang.language}`"
          >
            <image-picker
              v-if="lang.language.toLowerCase() === 'en'"
              :value.sync="portal.footerItems.leftLogo"
              :label="
                $t(
                  `components.portal.portal_settings.footer_items.left_logo_{0}`,
                  [lang.language.toUpperCase()]
                )
              "
            ></image-picker>
            <image-picker
              v-else
              :value.sync="
                portal.footerItems[
                  `leftLogo${$helpers.toPascalCase(lang.language)}`
                ]
              "
              :label="
                $t(
                  `components.portal.portal_settings.footer_items.left_logo_{0}`,
                  [lang.language.toUpperCase()]
                )
              "
            ></image-picker>
          </div>
          <div
            class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
            v-for="lang in languages"
            :key="`leftLogoLink${lang.language}`"
          >
            <no-autocomplete-textfield
              v-if="lang.language.toLowerCase() === 'en'"
              v-model="portal.footerItems.leftLogoLink"
              :label="
                $t(
                  `components.portal.portal_settings.footer_items.left_logo_link_{0}`,
                  [lang.language.toUpperCase()]
                )
              "
              clearable
            ></no-autocomplete-textfield>
            <no-autocomplete-textfield
              v-else
              v-model="
                portal.footerItems[
                  `leftLogoLink${$helpers.toPascalCase(lang.language)}`
                ]
              "
              :label="
                $t(
                  `components.portal.portal_settings.footer_items.left_logo_link_{0}`,
                  [lang.language.toUpperCase()]
                )
              "
              clearable
            ></no-autocomplete-textfield>
          </div>
        </v-layout>
      </v-form>
    </v-card-text>
  </expandable-material-card>
</template>

<script>
import { mapGetters } from "vuex";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import ExpandableMaterialCard from "./ExpandableMaterialCard.vue";
import ImagePicker from "./ImagePicker.vue";
export default {
  components: {
    NoAutocompleteTextfield,
    ExpandableMaterialCard,
    ImagePicker,
  },
  props: ["dataContainer"],
  data() {
    return {
      valid: true,
      portal: null,
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
  },
  watch: {
    dataContainer: {
      handler(v) {
        if (v !== null && v !== undefined) {
          this.portal = JSON.parse(JSON.stringify(v.portal));
        }
      },
    },
    portal: {
      handler(v) {
        this.$emit("update", v);
      },
      deep: true,
    },
    valid: {
      handler(v) {
        this.$emit("valid", v);
      },
    },
  },
  mounted() {
    if (this.dataContainer !== null && this.dataContainer !== undefined) {
      this.portal = JSON.parse(JSON.stringify(this.dataContainer.portal));
      this.$nextTick(() => {
        this.$emit("valid", this.valid);
      });
    }
  },
};
</script>
